module.exports = __webpack_public_path__ + "static/media/active-modal.96fae8a9.png";